import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'property';

const propertyService = {
  getPropertyByIds: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/properties/propertyByIds`,
      data,
    });
  },

  properties: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/properties`,
      data,
    });
  },

  updateProperty: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  createProperty: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteProperty: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  addPropertyOptionToList: (data, propertyId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/propertyOption/${encodeURIComponent(propertyId)}`,
      data,
    });
  },

  updatePropertyOption: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/propertyOption/${encodeURIComponent(id)}`,
      data,
    });
  },

  deletePropertyOptionFromList: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/propertyOption/${encodeURIComponent(id)}`,
      data,
    });
  },

  updateDefaultValue: (id, propertyId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/defaultValue/${encodeURIComponent(id)}/${encodeURIComponent(propertyId)}`,
    });
  },

  updateFormProperty: (id, formId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/formProperty/${encodeURIComponent(id)}/${encodeURIComponent(formId)}`,
    });
  },

  getPropertiesByFormId: (formId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/formProperties/${encodeURIComponent(formId)}`,
    });
  },

  getPropertyGroupsForSubmenus: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/propertyGroupForSubmenus`,
      data,
    });
  },

  updateFormGroupProperty: (id, formId, groupId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/formGroupProperty/${encodeURIComponent(id)}/${encodeURIComponent(formId)}/${encodeURIComponent(groupId)}`,
    });
  },
};
export default propertyService;
